import { useMutation, useQueryClient } from "react-query";
import { GET_COLLABORATION_NOTES } from "@constants/reactQueryKeys";
import { updateCollaborationNote } from "api/collaborationNotes";
import { useGlobalToast } from "components/GlobalToastProvider";

/**
 * Mutation hook for editing an existing collaboration note. Invalidates the
 * notes query on success.
 */
const useUpdateCollaborationNote = () => {
  const queryClient = useQueryClient();
  const { showToast } = useGlobalToast();

  const { mutateAsync, isLoading } = useMutation(
    ({
      clientId,
      providerId,
      noteId,
      body,
    }: {
      clientId: string;
      providerId: string;
      noteId: string;
      body: string;
    }) => updateCollaborationNote(clientId, providerId, noteId, { body }),
    {
      onSuccess: (_data, variables) => {
        queryClient.invalidateQueries([
          GET_COLLABORATION_NOTES,
          variables.clientId,
          variables.providerId,
        ]);
        showToast({ message: "Collaboration note updated" });
      },
      onError: () => {
        showToast({
          message: "Failed to update collaboration note",
          errorState: true,
        });
      },
    },
  );

  return { updateNote: mutateAsync, isUpdating: isLoading };
};

export default useUpdateCollaborationNote;
